/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DocumentsControllerFetchFileQueryResponse, DocumentsControllerFetchFilePathParams, DocumentsControllerFetchFileQueryParams, DocumentsControllerFetchFile400, DocumentsControllerFetchFile401, DocumentsControllerFetchFile403, DocumentsControllerFetchFile404 } from "../../models/documentsController/DocumentsControllerFetchFile";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { documentsControllerFetchFile } from "../../clients/documentsService/documentsControllerFetchFile";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const documentsControllerFetchFileQueryKey = (id: DocumentsControllerFetchFilePathParams["id"], params: DocumentsControllerFetchFileQueryParams = {}) => [{
  url: '/api/v1/documents/:id/file',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type DocumentsControllerFetchFileQueryKey = ReturnType<typeof documentsControllerFetchFileQueryKey>;
export function documentsControllerFetchFileQueryOptions(id: DocumentsControllerFetchFilePathParams["id"], params?: DocumentsControllerFetchFileQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = documentsControllerFetchFileQueryKey(id, params);
  return queryOptions<DocumentsControllerFetchFileQueryResponse, ResponseErrorConfig<DocumentsControllerFetchFile400 | DocumentsControllerFetchFile401 | DocumentsControllerFetchFile403 | DocumentsControllerFetchFile404>, DocumentsControllerFetchFileQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return documentsControllerFetchFile(id, params, config);
    }
  });
}

/**
 * @summary Fetch the actual document file from storage
 * {@link /api/v1/documents/:id/file}
 */
export function useDocumentsControllerFetchFile<TData = DocumentsControllerFetchFileQueryResponse, TQueryData = DocumentsControllerFetchFileQueryResponse, TQueryKey extends QueryKey = DocumentsControllerFetchFileQueryKey>(id: DocumentsControllerFetchFilePathParams["id"], params?: DocumentsControllerFetchFileQueryParams, options: {
  query?: Partial<QueryObserverOptions<DocumentsControllerFetchFileQueryResponse, ResponseErrorConfig<DocumentsControllerFetchFile400 | DocumentsControllerFetchFile401 | DocumentsControllerFetchFile403 | DocumentsControllerFetchFile404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? documentsControllerFetchFileQueryKey(id, params);
  const query = useQuery({
    ...documentsControllerFetchFileQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<DocumentsControllerFetchFile400 | DocumentsControllerFetchFile401 | DocumentsControllerFetchFile403 | DocumentsControllerFetchFile404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}